export type BuyerMotionCard = {
  id: string;
  label: string;
  summary: string;
  decisionFocus: string;
  defaultOnboardingMode: 'self_managed' | 'ai_guided' | 'human_assisted';
  primaryDemoLabel: string;
  primaryDemoHref: string;
  builderDemoHref: string;
  commercialPath: string;
};

export type OnboardingModeCard = {
  id: 'self_managed' | 'ai_guided' | 'human_assisted';
  label: string;
  summary: string;
  essentialInputs: string[];
  deferredInputs: string[];
  recommendedActionLabel: string;
  recommendedActionHref: string;
};

export const BUYER_MOTION_CARDS: BuyerMotionCard[] = [
  {
    id: 'fast-roi',
    label: 'Fast ROI / Budget-Controlled',
    summary: '适合 SME 和预算敏感客户，重点是少步骤、快速试用、快速感受到价值。',
    decisionFocus: '3 分钟懂、1 天能试、1 周见效果。',
    defaultOnboardingMode: 'ai_guided',
    primaryDemoLabel: 'Warehouse Planner',
    primaryDemoHref: '/admin/packs?showcase=warehouse-planner',
    builderDemoHref: '/admin/builder?demo=warehouse-planner',
    commercialPath: 'Starter + free credits + quick-start trial',
  },
  {
    id: 'process-improvement',
    label: 'Process Improvement / Margin Expansion',
    summary: '适合中型成长客户，重点是流程改进、例外处理和管理可视化。',
    decisionFocus: '证明 package、advisor、simulation 和 install 能形成闭环。',
    defaultOnboardingMode: 'human_assisted',
    primaryDemoLabel: 'Haulage Control Tower',
    primaryDemoHref: '/admin/packs?showcase=haulage-control-tower',
    builderDemoHref: '/admin/builder?demo=haulage-control-tower',
    commercialPath: 'Growth + assisted onboarding + simulation evidence',
  },
  {
    id: 'ownership-sensitive',
    label: 'Control / Ownership Sensitive',
    summary: '适合大型/集团/高利润客户，重点是控制权、私有化、私有模型与源码边界。',
    decisionFocus: '证明可持续演化与主权控制，而不是只讲功能页。',
    defaultOnboardingMode: 'human_assisted',
    primaryDemoLabel: 'Finance Foundation',
    primaryDemoHref: '/admin/packs?showcase=finance-foundation',
    builderDemoHref: '/admin/builder?demo=finance-foundation',
    commercialPath: 'Sovereign path + private deployment/model + extension rights',
  },
  {
    id: 'network-driven',
    label: 'Network-Driven / Ecosystem Fit',
    summary: '适合多方协作供应链场景，重点是 customer/vendor/partner 一起进入网络。',
    decisionFocus: '先让外部参与者成为 member，再逐步转成 tenant。',
    defaultOnboardingMode: 'ai_guided',
    primaryDemoLabel: 'Haulage Control Tower',
    primaryDemoHref: '/admin/packs?showcase=haulage-control-tower',
    builderDemoHref: '/admin/builder?demo=haulage-control-tower',
    commercialPath: 'Network-first + member growth + share/invite conversion',
  },
];

export const ONBOARDING_MODE_CARDS: OnboardingModeCard[] = [
  {
    id: 'self_managed',
    label: 'Self-Managed',
    summary: '客户自己推进 onboarding，平台只给最轻的 default path 和必要 guardrail。',
    essentialInputs: ['公司名', '联系人', '主要目标', '首个 archetype'],
    deferredInputs: ['模块深度设置', '审批边界', '复杂 integration', '高级 sharing/trust scope'],
    recommendedActionLabel: 'Open Tenant Manager',
    recommendedActionHref: '/admin/tenants',
  },
  {
    id: 'ai_guided',
    label: 'AI-Guided',
    summary: '默认推荐模式。AI 负责问诊、推荐 demo、建议下一步，并在必要时升级给 human。',
    essentialInputs: ['公司名', 'buyer motion', '目标场景', 'admin contact'],
    deferredInputs: ['模块参数', 'risk/compliance detail', 'integration mapping', 'advanced billing setup'],
    recommendedActionLabel: 'Open Business Packages',
    recommendedActionHref: '/admin/packs',
  },
  {
    id: 'human_assisted',
    label: 'Human-Assisted',
    summary: '复杂客户由 sales / delivery owner 带着走，AI 负责 checklist、missing data 和 readiness。',
    essentialInputs: ['客户画像', 'current system map', '目标模块', '商业边界'],
    deferredInputs: ['module deep config', 'private deployment detail', 'source/license boundary', 'migration specifics'],
    recommendedActionLabel: 'Open Task Center',
    recommendedActionHref: '/admin/tasks',
  },
];

